import { CofStatus } from '../hoc/common/types';

import cn from './styles.module.css';

const getCofStatus = (status: CofStatus) => {
  let cofStatus: string;
  let cofStatusClassName = cn.cofDefault;

  switch (status) {
    case CofStatus.APPROVED:
      cofStatus = 'Approved';
      cofStatusClassName = cn.cofApproved;
      break;
    case CofStatus.ARCHIVED:
      cofStatus = 'Archived';
      cofStatusClassName = cn.cofArchived;
      break;
    case CofStatus.REJECTED:
      cofStatus = 'Rejected';
      cofStatusClassName = cn.cofRejeted;
      break;
    case CofStatus.PENDING_REVIEW:
      cofStatus = 'Pending review';
      break;
    default:
      cofStatus = status;
      break;
  }

  return { cofStatus, cofStatusClassName };
};

export default getCofStatus;
